import { useEffect, useState } from 'react';

const MS_PER_DAY = 86_400_000;

/**
 * Whole days remaining until `endDate` (ISO string), never negative. Recomputes
 * hourly so a long-lived tab stays roughly accurate. `null` end → `null`.
 */
export function useDaysUntil(endDate: string | null | undefined): number | null {
  const compute = (): number | null => {
    if (!endDate) return null;
    const end = new Date(endDate).getTime();
    if (Number.isNaN(end)) return null;
    return Math.max(0, Math.ceil((end - Date.now()) / MS_PER_DAY));
  };

  const [days, setDays] = useState<number | null>(compute);

  useEffect(() => {
    setDays(compute());
    const timer = window.setInterval(() => setDays(compute()), 3_600_000);
    return () => window.clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endDate]);

  return days;
}
